import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

var Feedback_Recent = View.extend({
    className: 'feedback-recent',

    events: {
        'click': 'onOpenFeedback'
    },

    dom_handlers: {
        onOpenFeedback: function(e) {
            Modals.openFeedbackSidebar(this.model.id);
        }
    },

    initialize: function(options) {
        this.workflow = options.workflow;
    },

    render: function() {
        var content = '';
        var subject = '';
        var category = '';

        if (this.model.isDesign() && this.model.isPdf()) {
            subject = this.model.get('page');
        } else if (this.model.get('title')) {
            subject = this.model.get('title');
        } else if (this.model.get('description')) {
            subject = this.model.get('description');
        } else {
            subject = this.model.escape('page');
        }

        if (this.model.get('category')) {
            this.model.get('category').split(',').forEach((category_name) => {
                category += '<span class="text-primary text-medium font-weight-medium">#' + Util.htmlEntities(category_name) + '</span>';
            });
        }

        var project_name = Cache.project.get(this.model.get('project_id')).escape('name') || '';

        content +=
        '<div class="flex-between">' +
            '<div class="text-info text-medium font-weight-medium">' + project_name + '</div>' +
            '<div class="text-info text-medium">' + Util.moment(this.model.get('time')) + '</div>' +
        '</div>' +
        '<div class="text-default font-weight-medium ellipsis margin-top-8">' + Util.htmlEntities(subject) + '</div>' +
        (this.workflow ?
        '<div class="feedback-status">' +
            '<span class="workflow-option-colour" style="background-color:' + this.workflow.get('colour') + ';"></span>' +
            '<span>' + this.workflow.escape('name') + '</span>' +
        '</div>' : '') +
        (category ?
        '<div class="feedback-category">' + category + '</div>' : '');

        this.$el.html(content);

        return this;
    }
});

export default Feedback_Recent;